(function () {
    'use strict';

    angular
        .module('app.tenantReporting')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'tenantreporting',
                  config: {
                      abstract: true,
                      url: '/tenantreporting',
                      template: '<ui-view/>',
                      settings: {
                          authMode: 1
                      },
                      resolve: {
                          authenticationRequired: ['userService', function (userService) {
                              if (userService.tenantId() != "1") {
                                  throw { name: "NotAdmin" };
                              }
                          }]
                      }
                  }
              },
            {
                state: 'tenantreporting.reports',
                config: {
                    url: '/reports',
                    templateUrl: 'app/tenantReporting/reports.html?v=' + opsIncludeVersion,
                    controller: 'TenantReportsController',
                    controllerAs: 'vm',
                    title: 'Tenant Reports'
                }
            }

          
        ];
    }
})();
